import * as React from 'react';
import {SVGProps} from 'react';
const SearchSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
    <path
      fillRule="evenodd"
      d="M11 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m.075 5.489c-.346-.345-.886-.382-1.32-.158a6 6 0 1 1 2.576-2.576c-.224.434-.187.974.158 1.32l2.218 2.218a1 1 0 0 1-1.414 1.414z"
      clipRule="evenodd"
    />
  </svg>
);
export default SearchSvg;
